




























import {Component, Vue, Watch} from "vue-property-decorator";
import DropupLayout from "@/views/Dropups/DropupLayoutV2.vue";
import ReceiverPhone from "@/views/Dropups/views/ReceiverPhone.vue";
import DroppoButton from "@/views/components/DroppoButton.vue";
import {getFormattedPhoneNumber} from "@/helpers/PhoneHelper";
import {IPhoneNumber} from "@/models/IPhoneNumber";
import {namespace} from "vuex-class";
import {ORDER_PROCESS_DROPUP_PAGE} from "@/constants/orders";

const shipmentStore = namespace("shipment");

@Component({
  name: 'OrderButtonPhone',
  components: {
    DropupLayout,
    ReceiverPhone,
    DroppoButton,
  },
})
export default class OrderButtonPhone extends Vue {
  @shipmentStore.Action("setToPhoneNumber")
  private setToPhoneNumber!: (phone: IPhoneNumber) => void;

  @shipmentStore.Getter("getToPhoneNumberSpaces")
  private getToPhoneNumberSpaces!: string;

  @shipmentStore.Getter("getToPhoneNumber")
  private getToPhoneNumber!: IPhoneNumber;

  private dropupOpen: boolean = false;

  private toPhone: IPhoneNumber = {
    extension: "",
    number: "",
  };

  @Watch('$route')
  private checkDropup() {
    const dropupParam = this.$route.params.dropup ? this.$route.params.dropup : ORDER_PROCESS_DROPUP_PAGE.EMPTY_PAGE;

    if (dropupParam === ORDER_PROCESS_DROPUP_PAGE.RECEIVER_PHONE) {
      this.dropupOpen = true; // to open with the route
    }
  }

  private created() {
    this.toPhone = this.getToPhoneNumber;
    this.updateIsValidData();
    this.checkDropup();
  }

  get isDataValid(): boolean {
    return this.toPhone.number !== '' && this.toPhone.extension  !== '';
  }

  get formattedPhoneNumber(): string {
    return getFormattedPhoneNumber(this.toPhone);
  }

  private goAddPhoneNumber() {
    this.dropupOpen = true;
  }

  private savePhoneAndCloseDropup(phoneData: IPhoneNumber) {
    this.updatePhoneData(phoneData);
    this.closeDropup();
  }

  private updatePhoneData(phoneData: IPhoneNumber) {
    this.toPhone = phoneData;
    this.setToPhoneNumber(this.toPhone);
    this.updateIsValidData();
  }

  private updateIsValidData() {
    this.$emit("orderButtonPhone:isDataValid", this.isDataValid );
  }

  private closeDropup() {
    this.dropupOpen = false;
  }
}
